import { render } from "./selecdServe.vue?vue&type=template&id=adf1a99a&scoped=true"
import script from "./selecdServe.vue?vue&type=script&lang=js"
export * from "./selecdServe.vue?vue&type=script&lang=js"

import "./selecdServe.vue?vue&type=style&index=0&id=adf1a99a&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adf1a99a"]])

export default __exports__